import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { MusicRoutes } from "./Constants/routes";

const Music = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {MusicRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/media" />
      </Switch>
    </>
  );
};

export default Music;
